import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  ArrowLeft, 
  BarChart3, 
  FileText, 
  Settings
} from 'lucide-react'
import ManualTestTrades from '../components/ManualTestTrades'
import ManualTestDetailPage from '../components/ManualTestDetailPage'
import ManualTestStatsPage from '../components/ManualTestStatsPage'

import Navigation from '../components/Navigation'

type TabType = 'trades' | 'detail' | 'stats'

export default function ManualTestPage() {
  const { strategyId } = useParams<{ strategyId: string }>()
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState<TabType>('trades')

  const tabs = [
    {
      id: 'trades' as TabType,
      label: '交易记录',
      icon: FileText,
      description: '添加和管理手动测试交易记录'
    },
    {
      id: 'detail' as TabType,
      label: '详细记录',
      icon: Settings,
      description: '查看和编辑详细的交易记录信息'
    },
    {
      id: 'stats' as TabType,
      label: '统计分析',
      icon: BarChart3,
      description: '查看详细的统计分析和图表'
    }
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case 'trades':
        return <ManualTestTrades strategyId={strategyId!} />
      case 'detail':
        return <ManualTestDetailPage strategyId={strategyId!} />
      case 'stats':
        return <ManualTestStatsPage strategyId={strategyId!} />
      default:
        return <ManualTestTrades strategyId={strategyId!} />
    }
  }

  return (
    <div className="min-h-screen animate-fadein">
      <Navigation />
      {/* 主要内容 */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 页面头部 */}
        <div className="card mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gradient mb-2">手动测试管理</h1>
              <p className="text-white/70">管理策略的手动测试交易记录和统计分析</p>
            </div>
            <button
              onClick={() => navigate(-1)}
              className="btn-secondary flex items-center"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              返回
            </button>
          </div>
        </div>

        {/* 标签页 */}
        <div className="card">
          <div className="border-b border-white/20">
            <div className="flex overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center px-6 py-4 text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'text-ocean-primary border-b-2 border-violet-500 bg-white/5'
                        : 'text-ocean-secondary hover:text-ocean-primary hover:bg-white/5'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-2" />
                    {tab.label}
                  </button>
                )
              })}
            </div>
          </div>
          
          <div className="p-6">
            {renderTabContent()}
          </div>
        </div>
      </main>
    </div>
  )
} 